import { CheckCircle, XCircle } from 'phosphor-react'
import { toast } from 'react-toastify'
import { useExpertBankDataMutation } from '../../../../../../services/hooks/experts/mutations/useExpertBankData'
import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'
import { getErrorMessage } from '../../../../../../utils/getErrorMessage'
import { BankDataForm } from '../../../../../../components/Forms/BankDataForm'

interface Props {
  data?: ExpertDomain
  save: () => void
}

export const BankForm = ({ data, save }: Props) => {
  const { mutate, isLoading } = useExpertBankDataMutation()

  const onSaveExpert = (values: any) => {
    if (data?.id) {
      mutate(
        { id: data?.id, data: values },
        {
          onSuccess () {
            toast('Dados bancários salvos com sucesso!', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              closeButton: false,
              icon: (
                <CheckCircle
                  size={48}
                  className="mx-auto my-auto text-alert-success"
                />
              ),
              className: 'bg-green-50',
            })
            save()
          },
          onError (error: unknown) {
            toast(getErrorMessage(error), {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              closeButton: false,
              icon: (
                <XCircle
                  size={48}
                  className="mx-auto my-auto text-alert-error"
                />
              ),
              className: 'bg-red-50',
            })
          },
        }
      )
    }
  }

  return (
    <BankDataForm
      isSubmitting={isLoading}
      defaultValues={data?.bankData || undefined}
      onSubmit={onSaveExpert}
    />
  )
}
